import type { MaterialFormula } from "./types.js";
import { ceilSafe, requirePerimeter, resolveInput, round2 } from "./util.js";

/** ปูกระเบื้องพื้น ขนาดแผ่นด้านละ tileSizeM (ค่าเริ่มต้น 0.6 ม.) */
export const floorTile: MaterialFormula = (input) => {
  const r = resolveInput(input);
  const perimeter = requirePerimeter(r);
  const { area, waste, tileSizeM } = r;
  return [
    { key: "tile", name_th: "กระเบื้อง", qty: ceilSafe((area / (tileSizeM * tileSizeM)) * (1 + waste)), unit: "แผ่น", qty_basis: "area/size^2 x (1+waste)" },
    { key: "tile_adhesive", name_th: "กาวซีเมนต์", qty: round2(4.5 * area), unit: "กก.", qty_basis: "4.5 กก./ตร.ม." },
    { key: "grout", name_th: "ยาแนว", qty: round2(0.4 * area), unit: "กก.", qty_basis: "0.4 กก./ตร.ม." },
    { key: "spacer", name_th: "Tile Spacer", qty: ceilSafe(8 * area), unit: "ชิ้น", qty_basis: "8 ชิ้น/ตร.ม." },
    { key: "edge_trim", name_th: "คิ้ว", qty: round2(perimeter), unit: "ม.", qty_basis: "2(W+L)" },
  ];
};
